export default "__VITE_ASSET__9rkmE58V__"